var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _require = require('@babel/core'),
    t = _require.types;

var _require2 = require('@babel/helper-plugin-utils'),
    declare = _require2.declare;

var _require3 = require('@mdx-js/util'),
    startsWithCapitalLetter = _require3.startsWithCapitalLetter;

var BabelPluginApplyMdxTypeProp = function BabelPluginApplyMdxTypeProp() {
  "use strict";

  _classCallCheck(this, BabelPluginApplyMdxTypeProp);

  var names = [];
  this.state = {
    names: names
  };
  this.plugin = declare(function (api) {
    api.assertVersion(7);
    return {
      visitor: {
        JSXOpeningElement: function JSXOpeningElement(path) {
          var jsxName = path.node.name.name;

          if (startsWithCapitalLetter(jsxName)) {
            names.push(jsxName);
            path.node.attributes.push(t.jSXAttribute(t.jSXIdentifier("mdxType"), t.stringLiteral(jsxName)));
          }
        }
      }
    };
  });
};

module.exports = BabelPluginApplyMdxTypeProp;